import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';
import cepState from 'states/cep.states';
import Alert from 'yoda-ui/components/Alert';
import Box from 'yoda-ui/components/Box';
import { fromUnitsToRem, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

const StatusBanner: FC = () => {
  const cepStateValue = useSnapshot(cepState);
  const { t } = useTranslation();

  return (
    <Alert severity='info' hideDefaultIcon
      sx={
        {
          paddingY: fromUnitsToRem(YodaSpacing.xSmall),
          paddingX: YodaSpacing.medium,
        }
      }
    >
      <Box
        display="flex"
        flexDirection="row"
        fontSize={ YodaFontSize.xSmall }
        justifyContent="space-between"
        alignItems="center"
        color={ YodaColors.inherit }
      >
        <Box display="flex" flexDirection="row" color={ YodaColors.inherit }>
          <Box fontSize={ YodaFontSize.small } color={ YodaColors.inherit } whiteSpace='nowrap'>
            <Box
              fontWeight={ YodaFontWeight.medium }
              color={ YodaColors.inherit }
              component="span">{ t('maya_side_display_banner_update') }
            </Box>
            <Box
              fontWeight={ YodaFontWeight.light }
              color={ YodaColors.inherit }
              component="span">
              { new Date(cepStateValue.cep?.updated).toLocaleString('fr-FR') }
            </Box>
          </Box>
        </Box>
      </Box>
    </Alert>
  );
};

export default StatusBanner;
